"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPropertiesDestination = void 0;
var tslib_1 = require("tslib");
var destination_1 = require("./base/destination");
var destination_type_1 = require("./utils/destination-type");
var CustomPropertiesDestination = (function (_super) {
    tslib_1.__extends(CustomPropertiesDestination, _super);
    function CustomPropertiesDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CustomPropertiesDestination.prototype, "destinationType", {
        get: function () { return destination_type_1.DestinationType.CustomPropertiesDestination; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(CustomPropertiesDestination.prototype, "controlCharHT", {
        get: function () { return null; },
        enumerable: false,
        configurable: true
    });
    ;
    CustomPropertiesDestination.prototype.createClone = function () {
        return new CustomPropertiesDestination(this.importer);
    };
    CustomPropertiesDestination.onPropname = function (_importer, _parameterValue, _hasParameter) {
    };
    CustomPropertiesDestination.onStaticval = function (_importer, _parameterValue, _hasParameter) {
    };
    CustomPropertiesDestination.onProptType = function (_importer, _parameterValue, _hasParameter) {
    };
    CustomPropertiesDestination.onLinkval = function (_importer, _parameterValue, _hasParameter) {
    };
    return CustomPropertiesDestination;
}(destination_1.DestinationBase));
exports.CustomPropertiesDestination = CustomPropertiesDestination;
